import { defaultParseSearch } from "@tanstack/react-router";

// Public URLs name pages; scoped router locations retain the org/project in each browser history entry.
const SELECTED = "~";
const projectSections = new Set<string>();
const orgSections = new Set<string>();
const catalogSections = new Set(["images", "environments", "trainingruntimes", "models"]);

export function registerConsolePaths(paths: string[]) {
  for (const path of paths) {
    const parts = path.split("/").filter(Boolean);
    if (parts[0] !== "$org") continue;
    const section = parts[1] === "$project" ? parts[2] : parts[1];
    if (section && !section.startsWith("$")) (parts[1] === "$project" ? projectSections : orgSections).add(section);
  }
}

/** Expand a directly opened short URL; the authenticated org layout resolves the selected scope. */
export function expandConsoleURL(url: URL): URL {
  const parts = url.pathname.split("/").filter(Boolean);
  const section = parts[0] ?? "";
  if (section === "catalog" && catalogSections.has(parts[1] ?? "") && parts[2]) {
    url.pathname = `/${SELECTED}/nodus/${parts.slice(1).join("/")}`;
  } else if (orgSections.has(section)) {
    url.pathname = `/${SELECTED}${url.pathname}`;
    if (section === "billing" && parts.length === 1) url.pathname += "/overview";
  } else if (projectSections.has(section)) {
    url.pathname = `/${SELECTED}/${SELECTED}${url.pathname}`;
  }
  return url;
}

/** Only recognized scoped pages are shortened; auth, callbacks and external links keep their contracts. */
export function publicConsoleURL(url: URL): URL {
  const parts = url.pathname.split("/").filter(Boolean);
  if (parts[0] === "account") {
    url.searchParams.delete("org");
  } else if (parts[0] && parts[0] !== SELECTED) {
    if (orgSections.has(parts[1] ?? "")) url.pathname = `/${parts.slice(1).join("/")}`;
    else if (projectSections.has(parts[2] ?? "")) {
      const catalog = parts[1] === "nodus" && catalogSections.has(parts[2] ?? "") && parts[3];
      url.pathname = `${catalog ? "/catalog" : ""}/${parts.slice(2).join("/")}`;
    }
  }
  return url;
}

export function consoleMask(href: string) {
  const url = new URL(href, window.location.origin);
  const original = url.href;
  publicConsoleURL(url);
  if (url.href === original) return undefined;
  return { to: url.pathname, search: defaultParseSearch(url.search), hash: url.hash.slice(1), unmaskOnReload: false };
}
